import script from "./PubAffiliate.vue?vue&type=script&setup=true&lang=js"
export * from "./PubAffiliate.vue?vue&type=script&setup=true&lang=js"

import "./PubAffiliate.vue?vue&type=style&index=0&id=83bc7ba0&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83bc7ba0"]])

export default __exports__